import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import {ArticlesStore} from 'app/store/ArticlesStore';
import {getPage} from 'app/utils/articles/getPage';
import {isDesktop, iOSDevice} from 'app/utils';
import {Outlet} from 'react-router-dom';


interface ArticleProps {
  articlesStore?: ArticlesStore
  type: string
}

@inject('articlesStore')
@observer
export default class ArticlesByCategoriesLayout extends Component<ArticleProps> {
    constructor(props: ArticleProps) {
        super(props);
        this.props.articlesStore.init({page: getPage() || 1}, this.props.type);
    }

    componentDidMount(): void {
        if (!isDesktop() && !iOSDevice()) {
            document.body.style.minHeight = '100vh';
        }
    }

    componentWillUnmount(): void {
        if (!isDesktop() && !iOSDevice()) {
            document.body.style.minHeight = '';
        }
    }

    render(): React.ReactNode {
        return (
            <>
                <Outlet />
            </>
        );
    }
}
